<template>
  <forms-list-activity
      ref="userNotifications"
      :form-type="FORM_TYPE"
      :show-add="false"
      :custom-details="true"
      @details="openNotification"
      :column-mixins="columnMixins"
  >
  </forms-list-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import NotificationDetails from "@/components/notifications/NotificationDetails";
import IconClass from "@/components/datagrid/IconClass";
import UserNotification from "@/server/com/silkplm/model/users/UserNotification";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import ColumnMixin from "@/components/forms/customizations/mixins/ColumnMixin";

const FORM_TYPE = UserNotification;

export default {
  name: "UserNotificationsPanel",
  components: {FormsListActivity},

  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr("notifications","Notifications");
    },

    beforeClose() {
    },

    async canClose() {
      return true;
    },

    async openNotification(item) {
      await ActivityManager.showActivity(NotificationDetails, {notificationId: item.id});
    },

    async dblClickedNotification(item) {
      await ActivityManager.showActivity(NotificationDetails, {notificationId: item.id});
    },

  },

  data: function () {
    const that = this;
    return {
      lists: [],
      columnMixins: [
        new ColumnMixin('', {
          name: '', prop: 'iconClass', sortable: false,
          template: IconClass
        })
      ],
      permissions: new PermissionsSet(),
      FORM_TYPE,
    }
  },
}
</script>
